<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">Error</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">Dashboard</router-link>/
      <b>Error</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>

    <div class="row">
      <div class="col-md-12">
        <div class="card mb-4">
          <div class="card-body">
            <p>The table below shows the list of errors.</p>

            <div class="table-responsive">
              <table
                id="customers_tbl"
                class="display table table-striped table-bordered"
                style="width:100%; text-align: center;"
              >
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>IC No.</th>
                    <th>Order ID</th>
                    <th>Amount</th>
                    <!-- <th>Error Code</th> -->
                    <th>Error Message</th>
                    <th>Date</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(error, index) in errors" v-bind:key="index">
                    <td>{{ index + 1 }}</td>
                    <td>{{ error.ic_number }}</td>
                    <td>{{ error.bpgs_id }}</td>
                    <td>{{ error.amount }}</td>
                    <!-- <td>{{ error.error_code }}</td> -->
                    <td>{{ error.error_message }}</td>
                    <td>{{ error.created_at }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";

export default {
  name: "error_list",
  components: {},

  data() {
    return {
      errors: [],
      role: []
    };
  },

  methods: {
    loadCustomers() {
      let token = localStorage.getItem("token");

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .get("/error/all", {
            headers: {
              Authorization: "Bearer " + token
            }
          })
          .then(res => {
            // this.errors = res.data;

            let tbk = [];

            res.data.forEach(data => {
              if (data.bpgs_id.includes("TBK")) {
                tbk = {
                  ic_number: data.ic_number,
                  bpgs_id: data.bpgs_id,
                  amount: data.amount,
                  // "error_code": data.error_code,
                  error_message: data.error_message,
                  created_at: data.created_at
                };
                this.errors.push(tbk);
              }
            });

            this.destroyDatatable();
          })
          .then(function() {
            $("#customers_tbl").DataTable({
              dom: "Bfrtip",
              buttons: ["excel", "pdf"]
            });
          });
      }
    },

    destroyDatatable() {
      $("#customers_tbl")
        .DataTable()
        .destroy();
    },

    setEmail() {},

    customerDetails(ic_no, email, created_at) {
      localStorage.setItem("email", email);
      localStorage.setItem("created_at", created_at);
      // return "/customer/" + ic_no;

      this.$router.push("/customer/" + ic_no);
    }
  },

  beforeMount() {},

  mounted() {
    this.loadCustomers();
    this.setEmail();
  }
};
</script>
